import React, { createContext, useContext, useState } from "react";
import { Outlet } from "react-router-dom";

const BusinessPlanV2Context = createContext();

const BusinessPlanV2Provider = ({ children }) => {
	const [allBp, setAllBp] = useState([]);
	const [selectedPlan, setSelectedPlan] = useState(null);
	const [selectedStore, setSelectedStore] = useState(null);
	const [selectedSubmission, setSelectedSubmission] = useState(null);

	return (
		<BusinessPlanV2Context.Provider
			value={{
				allBp,
				setAllBp,
				selectedPlan,
				setSelectedPlan,
				selectedStore,
				setSelectedStore,
				selectedSubmission,
				setSelectedSubmission,
			}}>
			<Outlet />
		</BusinessPlanV2Context.Provider>
	);
};

export const useBpV2State = () => {
	return useContext(BusinessPlanV2Context);
};

export default BusinessPlanV2Provider;
